import { Box } from '@rbilabs/universal-components';

import { getDesignToken } from 'styles/constants';
export const QuestIncentiveWrapper = Box.withConfig({
  backgroundColor: getDesignToken('background-contrast-loyalty'),
});
